   <!-- Navigation -->
   <nav class="navbar navbar-inverse navbar-fixed-top" role="navigation" >
    <!-- Brand and toggle get grouped for better mobile display -->
    <div class="navbar-header" style="margin-bottom:10px;">
        <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-ex1-collapse">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
        </button>
        <a class="navbar-brand" href="/Login" style="color:#FFE600;">&nbsp;&nbsp;
            <img src="./assets/static/EYwhite.png" 
            style="display:inline-block !important;vertical-align:bottom !important;margin-left:2vw;" 
            height="35" width="35">
            <span style="color:#Fff!important;font-size:22px;"></span>
        </a>

    </div>

    <!-- Top Menu Items -->
    <!-- Sidebar Menu Items - These collapse to the responsive navigation menu on small screens -->

    <br /><br />

<div id="login-wrapper">
  <div style="border-radius:0 !important;margin-top:15vh  !important;margin-left:3vw!important;">
      <br />
      <h3 style="color:#fff;font-size:30px!important;font-weight:100;">Successfully Logged Out</h3>
      </div>
</div>


</nav>
<nav class="navbar navbar-inverse navbar-fixed-bottom" role="navigation" 
style="background-color:#fff !important;text-align:center;color:#999;padding:19px 10px;min-height:40px!important;">
  <span style="border-right:1px solid #999;padding-right:10px;">Ernst&Young 2016</span>
  <span style="border-right:1px solid #999;padding-right:10px;padding-left:10px;">Legal Information</span>
  <span style="padding-left:10px;">All Rights Reserved</span>
  </nav>
